import { WareInfoListVo } from '@/apis/order/order.interface';
import { useStores } from '@/app/csr-src/models';
import { useTranslation } from '@/i18n/client';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useOutletContext } from 'react-router-dom';
import OrderTabs from './components/orderTabs';
import styles from './orderList.module.scss';
// 埋点
import { sendPv } from '@/tracks/25335';
// 接口
import { getOchamaOrderConfig } from '@/apis/order/order.api';
import to from 'await-to-js';
// 图标
import VectorDown from '@/assets/icons/VectorDownBig.svg';
interface ProfileListContext {
  updateNumber: () => void;
  initRecommendMainSkus: (mainSkus: string) => void;
}

const OrderList = observer(() => {
  const { t } = useTranslation();
  const { orderStore } = useStores();

  const [ochamaConfigData, setOchamaConfigData] = useState<any>(null);

  // 埋点需要的数据
  const orderTabList = [
    {
      name: t('order.orderList.orderTabs.allTab'),
      state: '4096',
    },
    {
      name: t('order.orderList.orderTabs.unpaidTab'),
      state: '1',
    },
    {
      name: t('order.orderList.orderTabs.pendingReceiptTab'),
      state: '128',
    },
    {
      name: t('order.orderList.orderTabs.completedTab'),
      state: '1024',
    },
    {
      name: t('order.orderList.orderTabs.cancelledTab'),
      state: '-1',
    },
  ];

  // 接收父级传入的参数
  const { updateNumber, initRecommendMainSkus } = useOutletContext<ProfileListContext>();

  useEffect(() => {
    getOchamaOrderConfigHandler();
  }, []);

  // 查询是否展示ochama订单入口
  const getOchamaOrderConfigHandler = async () => {
    const [err, configData] = await to(getOchamaOrderConfig());

    if (err) {
      setOchamaConfigData(null);
    } else {
      if (String(configData?.code) === '200' && configData?.data) {
        setOchamaConfigData(configData?.data);
      } else {
        setOchamaConfigData(null);
      }
    }
  };

  const loadOrderList = () => {
    const orderInfo = sessionStorage.getItem('orderInfo') || '{}';
    // session 用完后清除，防止其他页面进入后显示不正确
    sessionStorage.removeItem('orderInfo');
    const orderInfoObj = JSON.parse(orderInfo);
    orderInfoObj.pageNum && orderStore.setPageNum(orderInfoObj.pageNum);
    orderInfoObj.orderType && orderStore.setOrderType(orderInfoObj.orderType);
    orderStore.getOrderList({
      page: orderInfoObj.pageNum
        ? String(orderInfoObj.pageNum)
        : orderStore.pageNum
          ? String(orderStore.pageNum)
          : '1',
      state: orderInfoObj.orderType ? orderInfoObj.orderType : orderStore.orderType || '4096',
    });
  };

  useEffect(() => {
    const tabName = orderTabList.find((item) => item?.state === orderStore.orderType)?.name;
    sendPv.OrderCenter_List({
      from_page: '',
      tab_name: tabName || t('order.orderList.orderTabs.allTab'),
    });
    loadOrderList();
  }, []);

  useEffect(() => {
    if (orderStore?.orderListInfo?.orderInfoDTOS?.length) {
      const allWareList =
        orderStore?.orderListInfo?.orderInfoDTOS?.map((item: { wareInfoList: WareInfoListVo[] }) =>
          item?.wareInfoList?.map((ware) => ware?.wareId),
        ) || [];
      const wareList = [].concat(...allWareList);
      // 使用 Set 去重
      const uniqueWareList = [...new Set(wareList)];
      // skuId最大10个
      const firstTenItems = uniqueWareList.slice(0, Math.min(uniqueWareList.length, 10));
      initRecommendMainSkus(firstTenItems.join(','));
    }
  }, [orderStore?.orderListInfo?.orderInfoDTOS]);

  // useEffect(() => {
  //   const orderInfo = sessionStorage.getItem("orderInfo") || "{}";
  //   const orderInfoObj = JSON.parse(orderInfo);
  //   setTimeout(() => {
  //     const orderList = orderStore?.orderListInfo?.orderInfoDTOS || [];
  //     const pageHeight = document.documentElement.scrollHeight;
  //     console.log(orderList.length, document.documentElement.scrollHeight);
  //     if (
  //       orderList.length &&
  //       !orderStore?.error &&
  //       orderInfoObj.scrollY > 436 &&
  //       orderInfoObj.scrollY <= pageHeight
  //     ) {
  //       console.log(orderInfoObj.scrollY, 23233);
  //       window.scrollTo(0, orderInfoObj.scrollY); // 页面跳转时滚动到顶部
  //     } else {
  //       console.log(55645666);
  //       window.scrollTo(0, 0); // 页面跳转时滚动到顶部
  //     }
  //   }, 600);
  // }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // 页面跳转时滚动到顶部
  }, []);

  return (
    <div className={styles.order_content}>
      <Helmet>
        <title>{t('seo.title.myOrders')} | Joybuy</title>
        <meta name='description' content={t('seo.description.allDesc')} />
      </Helmet>
      <div className={styles.order_title_wrap}>
        <div className={styles.order_title}>{t('order.orderList.title')}</div>
        {ochamaConfigData ? (
          <div
            className={styles.historyWrap}
            onClick={() => {
              if (ochamaConfigData?.url) {
                window.location.href = ochamaConfigData?.url;
              }
            }}
          >
            <div className={styles.entryText}>{ochamaConfigData?.text}</div>
            <div className={styles.entryWrap}>
              <div>{ochamaConfigData?.buttonText}</div>
              <VectorDown className={styles.entryIco} />
            </div>
          </div>
        ) : null}
      </div>
      <OrderTabs updateNumber={updateNumber} />
    </div>
  );
});

export default OrderList;
